export default __webpack_public_path__ + "static/media/4.64e14197.png";